import { sanitizeFileName } from '@mimir/common/platformAbstraction/filesystemLimitations';
import { makeDirWith } from '@mimir/client-common/upload/premiere';
import type { AdobePanelContext, ElectronContext } from '@mimir/common/context/applicationContext';
import type { Logger } from '@mimir/common/types/logger';

export enum SystemPath {
  /** The path to user data.  */
  USER_DATA = 'userData',

  /** The path to common files for Adobe applications.  */
  COMMON_FILES = 'commonFiles',

  /** The path to the user's default document folder.  */
  MY_DOCUMENTS = 'myDocuments',

  /** @deprecated. Use \c #Extension.  */
  APPLICATION = 'application',

  /** The path to current extension.  */
  EXTENSION = 'extension',

  /** The path to hosting application's executable.  */
  HOST_APPLICATION = 'hostApplication'
}

export const getSystemPath = (adobeContext: AdobePanelContext | ElectronContext, pathType: SystemPath) => {
  let systemPath = getSystemPathWithProtocolPrefix(pathType);
  if (adobeContext.isWindows) {
    systemPath = systemPath.replace('file:///', '').replace(/\//g, '\\');
  } else if (adobeContext.isMac) {
    systemPath = systemPath.replace('file://', '');
  }
  return systemPath;
};

export function makeDir(
  services: {
    logger: Logger;
    applicationContext: AdobePanelContext | ElectronContext;
  },
  dirPath: string,
) {
  return makeDirWith(services, dirPath);
}

export const getSanitizedFileNameForScript = (applicationContext: AdobePanelContext | ElectronContext, name: string) => {
  // Remove platform specific invalid characters and escape double quotes
  const sanitizedName = sanitizeFileName(name, applicationContext.isWindows).replace(/"/g, '\\"');

  return sanitizedName;
};

function getSystemPathWithProtocolPrefix(pathType: SystemPath) {
  return decodeURI(window.__adobe_cep__.getSystemPath(pathType));
}